// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import type { TaskTypeGroup } from '@evolvemep/api-ts';
import { Accordion, Card, Checkbox, Flex, Text } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';
import { useTaskTypes } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/useTaskTypes';

export const DefinedTaskTypeGroupSection = ({
  children,
  taskTypeGroup,
  checked,
  onSelectAll,
  disableGroupSelect,
  hideGroupSelect,
}: {
  taskTypeGroup: TaskTypeGroup;
  checked: boolean;
  children: ReactNode;
  onSelectAll: () => void;
  disableGroupSelect: boolean;
  hideGroupSelect: boolean;
}) => {
  const { hideSelect, workCellSetup } = useTaskTypes();

  return (
    <Card withBorder radius={5} mb={5} p={0}>
      <Accordion.Item value={taskTypeGroup.taskTypeGroupId} w="100%">
        <Accordion.Control w="100%" flex={1}>
          <Flex flex={1} align="center" gap="sm">
            {!hideSelect && !hideGroupSelect && (
              <Checkbox
                disabled={disableGroupSelect || (taskTypeGroup.hasAllTaskTypeMapped && workCellSetup)}
                checked={checked}
                onChange={onSelectAll}
                onClick={(e) => e.stopPropagation()}
              />
            )}
            <Text size="xs" fw="bold">
              {taskTypeGroup.name}
            </Text>
            {taskTypeGroup.hasAllTaskTypeMapped && workCellSetup && !hideSelect && (
              <AgGridStyleTooltip label="All tasks in this group are mapped to work cells.">
                <EvolveIcon icon="Pin" color="primary" size="sm" />
              </AgGridStyleTooltip>
            )}
          </Flex>
        </Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Card>
  );
};
